import React from 'react';
import './CarouselItem.css';

const imgUrl = 'img/HeaderImages/';

const CarouselItem = ({ active, backgroundImage, title, description }) => {
  return (
    <div
      id={backgroundImage === 'OutsideAR.jpg' ? 'special' : ''}
      className={'carousel-item ' + (active ? 'active' : '')}
      style={{ backgroundImage: 'url(' + imgUrl + backgroundImage + ')' }}
    >
      <div className="carousel-caption d-none d-md-block">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default CarouselItem;
